export default  {
"/checkout.php": "/checkout",
"/shop.php": "/shop",
"/profilo_atleta.php#settimanatipo": "settimana-tipo",
};

